import {Component, Input, Output, EventEmitter} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'exg-checkbox',
  templateUrl: './exg-checkbox.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: ExgCheckboxComponent, multi: true
  }]
})
export class ExgCheckboxComponent implements ControlValueAccessor {

  @Input() tiny = false;
  @Input() type = 'text';
  @Input() caption!: string;
  @Input() disabled!: string;
  @Output() valueChange = new EventEmitter();

  id = Math.random().toString(36).substring(2);


  _value: any = null;
  get value(): any {
    return this._value;
  }

  set value(obj: any) {
    this._value = obj;
    this.onChange(obj);
    this.onTouched(obj);
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor() {
  }

  // ControlValueAccessor -> OUT
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // ControlValueAccessor <- IN
  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this._value = obj;
  }

  // ---------------
}
